module.exports = __webpack_public_path__ + "static/research-984a42ee3bc7e87225cb767feca7122b.jpg";